exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ng:hover {\r\n  cursor: pointer;\n}\r\n", ""]);

// exports
